/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/column_headers.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { columnHeadersModule } from "../../../grids/grid_core/column_headers/m_column_headers";
import gridCore from "../m_core";
export const ColumnHeadersView = columnHeadersModule.views.columnHeadersView;
gridCore.registerModule("columnHeaders", columnHeadersModule);